import React from 'react';
import { Handle, Position } from 'reactflow';

const dataSourceOptions = [
  { value: 'vix', label: 'VIX (Volatility Index)', range: 'Typical: 12–35, spikes to 50+ in crises' },
  { value: 'gold', label: 'Gold (GLD ETF)', range: 'Typical: $150–$250 per share' },
  { value: 'us_dollar', label: 'US Dollar Index (UUP)', range: 'Typical: $25–$30 per share' },
  { value: 'treasury_10y', label: '10-Year Treasury Yield', range: 'Typical: 2%–5%, as a number (e.g. 4.2)' },
  { value: 'treasury_2y', label: '2-Year Treasury Yield', range: 'Typical: 2%–5%, as a number (e.g. 3.8)' },
  { value: 'treasury_spread', label: '10Y-2Y Treasury Spread', range: 'Typical: −0.5 to 2.5, negative = inverted yield curve' },
  { value: 'fed_funds_rate', label: 'Federal Funds Rate', range: 'Typical: 0%–5.5%, as a number (e.g. 5.33)' },
  { value: 'unemployment', label: 'Unemployment Rate', range: 'Typical: 3.5%–6%, as a number (e.g. 4.1)' },
  { value: 'consumer_sentiment', label: 'Consumer Sentiment', range: 'Typical: 50–100, higher = more optimistic' },
];

export default function DataNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  const selected = dataSourceOptions.find((o) => o.value === (data.source || 'vix')) || dataSourceOptions[0];

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #0ea5e9',
      background: 'var(--card)',
      minWidth: 200,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#38bdf8' }}>
        🌐 External Data
      </div>
      <select
        value={data.source || 'vix'}
        onChange={(e) => onChange('source', e.target.value)}
        style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        {dataSourceOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <div style={{ marginTop: 6, fontSize: 10, fontStyle: 'italic', color: 'var(--muted)', lineHeight: 1.4 }}>
        {selected.range}
      </div>
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#0ea5e9' }} />
    </div>
  );
}
